import { Route, Routes } from "react-router-dom";
import PersonaaSMiniApp from "../chat/PersonaaSMiniApp";
import './apps.css';

function CommandCenter({ disableAllPages = true }) {

    return (
        <div>
            <Routes>
                <Route path={'/'} element={<PersonaaSMiniApp disableAllPages={disableAllPages} />} />
            </Routes >
        </div >
    )
}

export default CommandCenter; 